var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 30H0V0H22.5V30Z",
    stroke: "#E5E7EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 22.5C16.5 20.6309 17.666 19.0371 18.8203 17.4492C19.125 17.0332 19.4297 16.6172 19.7227 16.1953C20.8828 14.5254 21.5625 12.5039 21.5625 10.3184C21.5625 4.61719 16.9453 0 11.25 0C5.55469 0 0.9375 4.61719 0.9375 10.3125C0.9375 12.498 1.61719 14.5254 2.77734 16.1895C3.07031 16.6113 3.375 17.0273 3.67969 17.4434C4.83984 19.0312 6.00586 20.6309 6.5625 22.4941H15.9375V22.5ZM11.25 30C13.8398 30 15.9375 27.9023 15.9375 25.3125V24.375H6.5625V25.3125C6.5625 27.9023 8.66016 30 11.25 30ZM6.5625 10.3125C6.5625 10.8281 6.14062 11.25 5.625 11.25C5.10938 11.25 4.6875 10.8281 4.6875 10.3125C4.6875 6.68555 7.62305 3.75 11.25 3.75C11.7656 3.75 12.1875 4.17188 12.1875 4.6875C12.1875 5.20312 11.7656 5.625 11.25 5.625C8.66016 5.625 6.5625 7.72266 6.5625 10.3125Z",
    fill: "#3B82F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.0124338c67467f9112316efa9592209d.svg";
export { ForwardRef as ReactComponent };